import { FC, memo } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { WithPostUid } from 'interfaces/feed'
import { FeedPostPageInner } from 'components/features/socialFeed/FeedPostPage/FeedPostPageInner'
import NavigationRedirect from 'components/atoms/navigation/NavigationRedirect'
import { OnboardingStepGuard } from 'components/features/pfm/OnboardingStepGuard/OnboardingStepGuard'
import { FeedGuard } from 'components/features/socialFeed/FeedGuard/FeedGuard'

type FeedPostPageRouteProps =
  & WithPostUid

export type FeedPostPageProps = RouteComponentProps<FeedPostPageRouteProps>

export const FeedPostPage: FC<FeedPostPageProps> = memo((props) => {
  const { postUid } = props.match.params

  if (!postUid) {
    return (
      <NavigationRedirect to='feedposts' />
    )
  }

  return (
    <FeedGuard>
      <OnboardingStepGuard>
        <FeedPostPageInner postUid={ postUid } />
      </OnboardingStepGuard>
    </FeedGuard>
  )
})
